/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Tile } from '../../models/tile';

export interface GetWidgetTiles$Params {
  orid?: number;
  usid?: number | null;
}

export function getWidgetTiles(http: HttpClient, rootUrl: string, params?: GetWidgetTiles$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Tile>>> {
  const rb = new RequestBuilder(rootUrl, getWidgetTiles.PATH, 'get');
  if (params) {
    rb.query('orid', params.orid, {});
    rb.query('usid', params.usid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Tile>>;
    })
  );
}

getWidgetTiles.PATH = '/api/DashboardManagement/getWidgetTiles';
